import { Routes } from '@angular/router';

export const equipmentRoutes: Routes = [
  { path: '', loadComponent: () => import('./equipment-list').then(m => m.EquipmentList) },
  { path: ':slug', loadComponent: () => import('./equipment-detail').then(m => m.EquipmentDetail) }
];
